import { useQuery } from '@tanstack/react-query';
import { getSecurityVestingData } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const useSecurityVestingQuery = (
	investorId: string | undefined,
	securityId: string | undefined,
	enabled: boolean
) => {
	return useQuery({
		queryKey: [
			API_PATHS.MIP_INVESTOR_VESTING_INVESTORID_SECURITYID_GET,
			{ investorId, securityId },
		],
		queryFn: ({ signal }) =>
			getSecurityVestingData(
				API_PATHS.MIP_INVESTOR_VESTING_INVESTORID_SECURITYID_GET,
				{ investorId, securityId },
				signal
			),
		enabled: enabled && !!investorId && !!securityId,
	});
};
